const uuid = require('uuid');
const Promise = require('bluebird');
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Modal } from 'react-bootstrap';
const _ = {
    filter:     require('lodash/filter'),
    find:       require('lodash/find'),
    findIndex:  require('lodash/findIndex'),
    forEach:    require('lodash/forEach'),
    map:        require('lodash/map'),
}

const Globals = require('../../../../app/globals');
const ShortCourseConstants = require('../../../../app/shared/ShortCourseConstants');

import SortableTable2 from '../table/SortableTable2';
import AccessibleIcon from '../common/AccessibleIcon';
import ControlledInput from '../common/ControlledInput';
import ControlledTextArea from '../common/ControlledTextArea';
import SingleAssetInput from '../common/SingleAssetInput';

const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');

const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');

const ShortCourseEditorActions = require('../../actions/ShortCourseEditorActions');
const ShortCourseEditorStore = require('../../stores/ShortCourseEditorStore');

const KeyboardUtil = require('../../util/keyboard');
const AssetUtil = require('../../util/asset');
const Strings = require('../../../../app/shared/Strings');

import ShortCourseActivityChooser from './ShortCourseActivityChooser';
import EditActivityDetailsModal from './EditActivityDetailsModal';
import EditSubskillModal from './EditSubskillModal';
import EditCoachStickersModal from './EditCoachStickersModal';
import CoachStyleEditorModal from './CoachStyleEditorModal';
import EditCoachScriptModal from './EditCoachScriptModal';
import VoiceOptionsModal from './VoiceOptionsModal';
import CourseCardEditorModal from './CourseCardEditorModal';
import CoursePhraseSystemEditorModal from './CoursePhraseSystemEditorModal';
import ImportCourseDataModal from './ImportCourseDataModal';

const GotoCommentIcon = require('./sidebar/GotoCommentIcon');

const propTypes = {
    projects: PropTypes.object.isRequired, // keyed by project id
    activities: PropTypes.array.isRequired,
    templates: PropTypes.object, // keyed by template id
    openConfirmModal: PropTypes.func.isRequired,
    onEditCoachText: PropTypes.func.isRequired,
    courseHash: PropTypes.string.isRequired,
    badgeTemplates: PropTypes.array,
};
const defaultProps = {};

const REMEDIAL_ACTIVITY_TYPES = Globals.short_course.REMEDIAL_ACTIVITY_TYPES;

function activityTypeOrder(activity_type) {
	if (activity_type === null) {
		return 0; // special case when activity is not for remedial use
	}
    let i = REMEDIAL_ACTIVITY_TYPES.indexOf(activity_type);
    if (i >= 0) {
        return (i+1);
    }
    //console.log(`activity_type ${activity_type} not recognized`);
    return 0;
}

const DEFAULT_BADGE_PARAMETERS = {
    issueBadge: false,
    badge_template_hash: ''
};

class ShortCourseSettingsEditor extends React.Component {
    constructor(props) {
        super(props);
        let storeState = ShortCourseEditorStore.getState();
        let courseStore = ShortCourseStore.getStateChannel(props.channelId);
        let shortCourseId = null;
        _.forEach(courseStore.shortCourses,(projData,project_id)=>{
            _.forEach(projData, (shortCourse,id)=>{
                if (shortCourse.hash === props.courseHash) {
                    shortCourseId = id;
                    return false;
                }
            });
            if (shortCourseId) {
                return false;
            }
        });
        const doc = storeState.shortCourseDoc;
        const subskills = doc.subskills;
		const mastery_score = doc.mastery_score;
        const perfect_score = doc.perfect_score;
        const tutorial_score_a2 = doc.tutorial_score_a2;
        const tutorial_score_a3 = doc.tutorial_score_a3;
        const badge_parameters = doc.badge_parameters || DEFAULT_BADGE_PARAMETERS
        const activityScoreCategories = ActivityStore.getStateScoreCategories().activityScoreCategories;
        const criteriaScoresStyle = doc.client_content.criteriaScoresStyle;
        
        let modalState = null;
        let coach_script_id = null;
        if (storeState.action.name === 'goToLocation') {
            if (storeState.currentNav.type === ShortCourseConstants.NAV_TYPES.CoachScript) {
                if (!storeState.currentNav.rich_text_id) {
                    modalState = 'coachScriptEditor';
                    coach_script_id = storeState.currentNav.id;
                }
                // else it will be opened after the rich text editor closes
            }
        }
        
        this.state = { 
            doc, 
            subskills, 
            mastery_score, perfect_score,tutorial_score_a2,tutorial_score_a3,
            badge_parameters,
            activityScoreCategories,
            modalState,coach_script_id, 
            shortCourseId,
        };
        this.unsubscribes = [
            ShortCourseStore.listen(this.onStoreChange),
            ShortCourseEditorStore.listen(this.onEditorChange),
            ActivityStore.listen(this.onActiviyStoreChange),
            ];
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    onStoreChange=(storeState)=>{
        let imageUpdateActionID = this.state.imageUpdateActionID;
        if (storeState.action) {
            if (storeState.action.id === imageUpdateActionID) {
                imageUpdateActionID = null;
                if (storeState.action.error) {
                    console.log("upload error",storeState.action.error); // TODO: display this?
                }
            }
        }
		this.setState({imageUpdateActionID});
    }
    
    onActiviyStoreChange=()=>{
        const activityScoreCategories = ActivityStore.getStateScoreCategories().activityScoreCategories;
        this.setState({activityScoreCategories,actionId_score_categories:null});
    }
    
    onEditorChange=(storeState)=>{
//        if (!storeState.action) {
//            return;
//        }
//        switch(storeState.action.name) {
//            case 'addSubskill':
//            case 'deleteSubskill':
//            case 'setSubskillValue':
//                break;
//            default:
//                return;
//        }
        const doc = storeState.shortCourseDoc;
        const subskills = doc.subskills;
		const mastery_score = doc.mastery_score;
		const perfect_score = doc.perfect_score;
        const tutorial_score_a2 = doc.tutorial_score_a2;
        const tutorial_score_a3 = doc.tutorial_score_a3;
        const badge_parameters = doc.badge_parameters || DEFAULT_BADGE_PARAMETERS;
        const edit_activity_id = this.state.edit_activity_id;
        let edit_subskill_relations = this.state.subskill_relations;
        if (edit_activity_id) {
            const cb = _.find(doc.content_blocks,{nova_activity_id:edit_activity_id});
            if (cb) {
                edit_subskill_relations = cb.subskill_relations;
            }
            else {
                console.log(`didn't find content block ${edit_activity_id}`);
                edit_subskill_relations = {};
            }
        }
        const criteriaScoresStyle = doc.client_content.criteriaScoresStyle;

        this.setState({doc, mastery_score, perfect_score, tutorial_score_a2, tutorial_score_a3, badge_parameters, subskills, edit_subskill_relations, criteriaScoresStyle});

        if (storeState.action && (storeState.action.name === 'addSubskill') && storeState.action.new_ss_hash) {
            this.openSubskillEditor(storeState.action.new_ss_hash);
        }
        else {
            if (storeState.action.name === 'goToLocation') {
                switch(storeState.currentNav.type) {
                    // case ShortCourseConstants.NAV_TYPES.Node: // nothing to do
                    // case ShortCourseConstants.NAV_TYPES.Comments: // nothing to do
                    case ShortCourseConstants.NAV_TYPES.Settings:
                        this.closeCoachScriptEditor();
                        break;
                    
                    case ShortCourseConstants.NAV_TYPES.CoachScript:
                        if (!storeState.currentNav.rich_text_id) {
                            this.openCoachScriptEditor(storeState.currentNav.id);
                        }
                        // else rich text editor will open first 
                        break;
                }
            }
        }
    }
    
    onAddActivity=(id)=>{
        const activity = _.find(this.props.activities,{id});
        if (!activity) {
            return;
        }
        
        return this.asyncGetScoreCategoriesForActivity(activity)
        .then((score_categories)=>{
            ShortCourseEditorActions.addContentBlock(uuid.v4(),{
                nova_activity_id: activity.activity_id, 
                activity_version: activity.version,
                score_categories,
            });
        });
    }
    
    onPreviewActivity=(activity_id)=>{
        this.props.onPreviewActivity(activity_id);
    }
    
    onEditActivity=(edit_activity_id)=>{
        const cb = _.find(this.state.doc.content_blocks,{nova_activity_id:edit_activity_id});
        if (!cb) {
            return;
        }
        const edit_subskill_relations = cb.subskill_relations;
        this.setState({edit_activity_id, edit_subskill_relations});
    }

    getEditActivityType=()=>{
        const nova_activity_id = this.state.edit_activity_id;
        const cb = _.find(this.state.doc.content_blocks,{nova_activity_id});
        if (!cb) {
            return;
        }
		return cb.activity_type;
    }
    
    asyncGetScoreCategoriesForActivity=(activity)=>{
        // returns true if resolve or reject was called
        var self = this;
        var _doGet = Promise.method(function(tries) {
            if (!self.unsubscribes) {
                throw new Error("component not mounted");
            }
            if (tries > 15) {
                throw new Error("timeout waiting for score_categories");
            }

            let score_categories = self.state.activityScoreCategories && self.state.activityScoreCategories[activity.id];
            if (score_categories && ActivityStore.isScoreCategoryVersion(activity.id, activity.version) ) {
                return score_categories;
            }

            
            if (self.state.actionId_score_categories) {
                // console.log("score_categories pending");
            }
            else {
                const actionId_score_categories = uuid.v4();
                self.setState({actionId_score_categories},()=>{
                    // console.log(`requesting score_categories for activity ${activity.id} version ${activity.version}`);
                    ActivityActions.getActivityScoreCategories(actionId_score_categories, activity.id, activity.version);
                });
            }
            
            console.log("waiting 1 second");
            return Promise.delay(1000)
            .then(()=>{
                return _doGet(tries+1);
            });
        });
        return _doGet(1);
    }
    
    getEditActivityScoreCategories=()=>{
        const nova_activity_id = this.state.edit_activity_id;
        const cb = _.find(this.state.doc.content_blocks,{nova_activity_id});
        if (!cb) {
            return [];
        }
        const activity = _.find(this.props.activities,{activity_id:nova_activity_id});
        if (!activity) {
            console.log(`didn't find ${nova_activity_id}`);
            return [];
        }
        let score_categories = this.state.activityScoreCategories && this.state.activityScoreCategories[activity.id];
        if (score_categories && ActivityStore.isScoreCategoryVersion(activity.id, activity.version)) {
            return score_categories;
        }
        if (this.state.actionId_score_categories) {
            console.log("already requesting score categories");
            return [];
        }
        
        const actionId_score_categories = uuid.v4();
        setTimeout(()=>{
            this.setState({actionId_score_categories});
            ActivityActions.getActivityScoreCategories(actionId_score_categories, activity.id, activity.version);
        },1);
        return [];
    }
    
    onSetActivityType=(activity_type)=>{
		if (activity_type === 'NOT_REMEDIAL') {
			activity_type = null;
		}
        ShortCourseEditorActions.setContentBlockValue(uuid.v4(),{
            nova_activity_id: this.state.edit_activity_id, 
            key: 'activity_type',
            value: activity_type
        });
    }
    
    
    onSetSubskillValue=(ss_hash,key,value)=>{
        const nova_activity_id = this.state.edit_activity_id;
        ShortCourseEditorActions.setContentBlockSubskillValue(uuid.v4(),{
            ss_hash,
            nova_activity_id, 
            key,
            value,
        });
    }
	
    onSyncSubskills=()=>{
        const nova_activity_id = this.state.edit_activity_id;
        const score_categories = this.getEditActivityScoreCategories();
        ShortCourseEditorActions.syncContentBlockSubskills(uuid.v4(),{nova_activity_id, score_categories});
    }

    onRemoveActivity=(activity_id)=>{
        const cb = _.find(this.state.doc.content_blocks,{nova_activity_id: activity_id});
		let node_count = 0;
		_.forEach(cb.node_relations,()=>{
			node_count++;
		});

		this.props.openConfirmModal({
			modalTitle: "Remove Content Block",
			text: node_count ? 
				`Content Block is used in ${node_count} nodes.  Are you sure you wish to delete it?` :
				`Are you sure you wish to delete this content block?`,
			confirmHandler: ()=>{ ShortCourseEditorActions.removeContentBlock(uuid.v4(),activity_id) }
		});
    }
    
    openSubskillEditor=(hash)=>{
        this.setState({
            subskill_hash: hash,
            modalState: 'subskillEditor',
        });
    }
    
    closeSubskillEditor=()=>{
        if (this.state.modalState === 'subskillEditor') {
            this.setState({
                subskill_hash: null,
                modalState: null,
            });
        }
    }

    addSubskill=()=>{
        ShortCourseEditorActions.addSubskill(uuid.v4());
    }
    
    deleteSubskill=(hash)=>{
		let cb_use_count = 0;
		let node_use_count = 0;
        _.forEach(this.state.doc.content_blocks,(cb)=>{
			if (cb.subskill_relations[hash]) {
				cb_use_count++;
			};
		});
		let ss = _.find(this.state.doc.subskills,{hash});
		if (ss) {
			_.forEach(ss.node_relations,()=>{
				node_use_count++;
			});
		}
		this.props.openConfirmModal({
			modalTitle: "Remove Subskill",
			text: (cb_use_count||node_use_count) ? 
				`Subskill is used in ${cb_use_count} content blocks and ${node_use_count} nodes.  Are you sure you wish to delete it?` :
				`Are you sure you wish to delete this subskill?`,
			confirmHandler: ()=>{ ShortCourseEditorActions.deleteSubskill(uuid.v4(),hash) }
		});
    }
	
    openCoachStickerEditor=()=>{
        this.setState({
            modalState: 'coachStickersEditor',
        });
    }
    
    closeCoachStickerEditor=()=>{
        if (this.state.modalState === 'coachStickersEditor') {
            this.setState({
                modalState: null,
            });
        }
    }
    
    openCoachStyleEditor=()=>{
        this.setState({
            modalState: 'coachStyleEditor',
        });
    }
    
    onChangeCriteriaScoresStyle=(key,value)=>{
        ShortCourseEditorActions.changeCriteriaScoresStyle(uuid.v4(), {key,value}); 
    }
    
    closeCoachStyleEditor=()=>{
        if (this.state.modalState === 'coachStyleEditor') {
            this.setState({
                modalState: null,
            });
        }
    }

    openVoiceOptions=()=>{
        this.setState({
            modalState: 'voiceOptions',
        });
    }

    onChangeVoiceOptions=(options)=>{
        ShortCourseEditorActions.changeVoiceOptions(uuid.v4(), options); 
    }

    closeVoiceOptions=()=>{
        if (this.state.modalState === 'voiceOptions') {
            this.setState({
                modalState: null,
            });
        }
    }
    
    getUsageData=()=>{
        return {
            channelId: this.props.channelId,
            shortCourseId: this.state.shortCourseId,
        };
    }
    
    openCourseCardOptions=()=>{
        this.setState({
            modalState: 'courseCard',
        });
    }

    onChangeCourseCardOptions=(options)=>{
        ShortCourseEditorActions.changeCourseCardOptions(uuid.v4(), options); 
    }

    closeCourseCardOptions=()=>{
        if (this.state.modalState === 'courseCard') {
            this.setState({
                modalState: null,
            });
        }
    }
    
    openCoursePhraseSystemEditor=()=>{
        this.setState({
            modalState: 'phraseSystem',
        });
    }

    onChangePhraseSystem=(phraseData)=>{
        ShortCourseEditorActions.changePhraseData(uuid.v4(), phraseData); 
    }
    

    closeCoursePhraseSystemEditor=()=>{
        if (this.state.modalState === 'phraseSystem') {
            this.setState({
                modalState: null,
            });
        }
    }
    
    openImportDataModal=()=>{
        this.setState({
            modalState: 'importData',
        });
    }
    
    closeImportDataModal=()=>{
        if (this.state.modalState === 'importData') {
            this.setState({
                modalState: null,
            });
        }
    }
    
	setMasteryScore=(e)=>{
		ShortCourseEditorActions.setMasteryScore(uuid.v4(), e.target.value);
	}
    
    setPerfectScore=(e)=>{
		ShortCourseEditorActions.setPerfectScore(uuid.v4(), e.target.value);
	}

    setTutorialScoreA2=(e)=>{
        ShortCourseEditorActions.setTutorialScoreA2(uuid.v4(), e.target.value);
    }

    setTutorialScoreA3=(e)=>{
        ShortCourseEditorActions.setTutorialScoreA3(uuid.v4(), e.target.value);
    }

    
    setIssueBadge=(e)=>{
        let badge_parameters = { ... this.state.badge_parameters, issueBadge: e.target.checked};
        ShortCourseEditorActions.setBadgeParameters(uuid.v4(), badge_parameters);
    }

    setBadgeTemplateId=(e)=>{
        let badge_template_hash = e.target.value;
        let entry = _.find(this.props.badgeTemplates,{badge_template_hash});
        if (!entry) {
            return;
        }
        let badge_parameters = { ... this.state.badge_parameters, badge_template_hash:badge_template_hash };
        ShortCourseEditorActions.setBadgeParameters(uuid.v4(), badge_parameters);
    }

    openCoachScriptEditor=(coach_script_id)=>{
        this.setState({
            modalState: 'coachScriptEditor',
            coach_script_id,
        });
    }
    
    closeCoachScriptEditor=()=>{
        if (this.state.modalState === 'coachScriptEditor') {
            this.setState({
                modalState: null,
            });
        }
    }
    
    onEditCoachText=(e)=>{
        let id = e.target.value;
        if (id === 'add') {
            ShortCourseEditorActions.addCoachRichText(uuid.v4());
            return;
        }
        const doc = this.state.doc;
        let entry = _.find(doc.client_content.rich_texts,{id});
        if (entry) {
            this.props.onEditCoachText({id:entry.id}, entry.displayName);
        }
    }
    
    renderActivityTable=(activityArray,practice)=>{
        
        let columns = [
            {
                displayName: '',
                key: 'edit_button',
                type: 'id',
                width: '1rem',
            },
            {
                displayName: '',
                key: 'play_button',
                type: 'id',
                width: '1rem',
            },
            {
                displayName: '',
                key: 'delete_button',
                type: 'id',
                width: '1rem',
            },
            {
                displayName: 'Level',
                key: 'activity_type',
                type: 'id',
                width: '10rem',
            },
            {
                displayName: 'Name',
                key: 'name',
                type: 'string',
                width: '18rem',
            },
            {
                displayName: 'Type',
                key: 'type',
                type: 'string',
                width: '15rem',
            },
        ];
        
        return (
            <div className="input-well">
                <div className="activity-table-area">
                    <SortableTable2 hideSearch showTotal={false}
                        classNameTable="font-size-md"
                        rows={activityArray}
                        rowsPerPage={100}
                        uniqueRowKey="activity_id"
                        defaultSort={{ key: 'name', type: 'string', asc: true }}
                        displayColumnCallbacks={{
                            edit_button: (activity_id)=>(
                                <button title="edit" onClick={()=>{this.onEditActivity(activity_id)}}>
                                    <AccessibleIcon className="fa fa-pencil table-button" label="edit"/>
                                </button>
                            ),
                            play_button: (activity_id)=>(
                                <button title="preview activity" onClick={()=>{this.onPreviewActivity(activity_id)}}>
                                    <AccessibleIcon className="fa fa-play-circle-o table-button" label="preview activity"/>
                                </button>
                            ),
                            delete_button: (activity_id)=>(
                                <button title="delete activity" onClick={()=>{this.onRemoveActivity(activity_id)}}>
                                    <AccessibleIcon className="fa fa-trash table-button" label="remove activity"/>
                                </button>
                            ),
							activity_type: (activity_type)=>(
								<span>{activity_type === null ? 'Not Remedial' : (activity_type || 'unspecified') }</span>
							),
                        }}
                        columns={columns}
                    />
                </div>
            </div>
        );
    } // renderActivityTable

    renderActivitiesEditor=()=>{
        let activityOptions = [];
        if (!this.state.doc) {
            return null;
        }
        const doc = this.state.doc;
        
        let existingRemedialActivities = [];
        let selectedActivities = [];
        _.forEach(doc.content_blocks,(cb,index)=>{
            if (REMEDIAL_ACTIVITY_TYPES.indexOf(cb.activity_type) < 0) {
                return; // don't show non-remedial content blocks
            }
            if (cb.type === Globals.short_course.content_block_type.ACTIVITY) {
                const activity_id = cb.nova_activity_id;
                const activity = _.find(this.props.activities,{activity_id});
                if (!activity) {
                    console.log(`did not find activity ${cb.nova_activity_id} for content block ${cb.hash}`);
                }
                let name = activity ? activity.title : `activity ${cb.nova_activity_id}`;
                let query = {activity_id, version: cb.activity_version};
                const template = this.props.templates[activity.template_id];
                const cb_type = (template && template.name) || cb.type;
                
                existingRemedialActivities.push({
                    activity_id: activity.activity_id,
                    query,
                    type: cb_type, // template name
                    name: name,
                    edit_button: activity.activity_id,
                    play_button: activity.activity_id,
                    delete_button:  activity.activity_id,
                    activity_type: cb.activity_type,
                });
                selectedActivities.push(activity);
            }
            /*else if (cb.type === Globals.short_course.content_block_type.ACTIVITY) { // TODO fixme. This is the same condition as the last
                console.log("TODO: chatbot activities");
            }*/
        });
        
        existingRemedialActivities.sort((a,b)=>{
            return activityTypeOrder(a.activity_type) - activityTypeOrder(b.activity_type);
        });
        
        return (
            <div className="formlike">
                <div className="content-block-area">
                    <ShortCourseActivityChooser
                        projects={this.props.projects}
                        activities={this.props.activities}
                        selectedActivities={selectedActivities}
                        templates={this.props.templates}
                        chooseButtonText={'Add Activity'}
                        chooseHandler={this.onAddActivity}
                    />
                    <label className="activity-label">Remedial Activities</label>
                    <div className="float-clear"/>
                    {this.renderActivityTable(existingRemedialActivities,false)}
                </div>
            </div>
        );
    } // renderActivitiesEditor
    
    renderSubskills=()=>{
        const subskills = this.state.subskills;
        let subskillRows = _.map(subskills,(ss,i)=>{
            return { ...ss, 
                edit_button: ss.hash,
                delete_button: ss.hash,
            };
        });
        return (
            <div className="formlike">
                <label>Subskills</label>
                <div className="input-well">
                    <div className="subskill-table-area">
                        <SortableTable2 hideSearch showTotal={false}
                            classNameTable="font-size-md"
                            rows={subskillRows}
                            rowsPerPage={100}
                            uniqueRowKey="hash"
                            defaultSort={{ key: 'index', type: 'int', asc: true }}
                            displayColumnCallbacksId={{
                                edit_button: (hash)=>(
                                    <button title="edit subskill" onClick={()=>{this.openSubskillEditor(hash)}}>
                                        <AccessibleIcon className="fa fa-pencil" label="edit subskill"/>
                                    </button>
                                ),
                                delete_button: (hash)=>(
                                    <button title="delete subskill" onClick={()=>{this.deleteSubskill(hash)}}>
                                        <AccessibleIcon className="fa fa-trash" label="delete subskill"/>
                                    </button>
                                )
                            }}
                            columns={[
                                    {
                                        displayName: 'Name',
                                        key: 'display_name',
                                        type: 'string'
                                    },
                                    {
                                        displayName: '',
                                        key: 'edit_button',
                                        type: 'string'
                                    },
                                    {
                                        displayName: '',
                                        key: 'delete_button',
                                        type: 'string'
                                    },
                                ]}
                        />
                    </div>
                </div>
                <button className="btn btn-primary add-subskill-button" onClick={this.addSubskill}>add subskill</button>
            </div>
        );
    } // renderSubskills
    
    renderElements=()=>{
        let anyBadgeTemplates = (this.props.badgeTemplates && this.props.badgeTemplates.length) ? true : false;
        let badgePrompt = this.state.badge_parameters.badge_template_hash;
        let coachRichTexts = _.filter(this.state.doc.client_content.rich_texts,{/*coach:true,*/coach_script_id:null});
        const coachScripts = _.filter(this.state.doc.client_content.coach_scripts,(scriptEntry)=>{
            let staticScriptEntry = _.find(ShortCourseConstants.COACH_SCRIPTS,{id:scriptEntry.id});
            if (staticScriptEntry && staticScriptEntry.deprecated) {
                return false;
            }
            return true;
        });
        
        return (
            <div className="formlike">
                <div className="formlike course-node-editor-top-section">
                    <div className="formlike">
                        <label htmlFor="short-course-mastery-score">Mastery Score</label>
                        <div className="input-well">
							<ControlledInput id="short-course-mastery-score" type="text" value={this.state.mastery_score} onChange={this.setMasteryScore}/>
                        </div>
                    </div>
                    <div className="formlike">
                        <label htmlFor="short-course-mastery-score">Perfect Score</label>
                        <div className="input-well">
							<ControlledInput id="short-course-perfect-score" type="text" value={this.state.perfect_score} onChange={this.setPerfectScore}/>
                        </div>
                    </div>
                    <div className="formlike">
                        <label htmlFor="short-course-mastery-score">Intermediate Assessment Tutoring Threshold</label>
                        <div className="input-well">
                            <ControlledInput id="short-course-tutorial-a2" type="text" value={this.state.tutorial_score_a2} onChange={this.setTutorialScoreA2}/>
                        </div>
                    </div>
                    <div className="formlike">
                        <label htmlFor="short-course-mastery-score">Proficient Assessment Tutoring Threshold</label>
                        <div className="input-well">
                            <ControlledInput id="short-course-tutorial-a3" type="text" value={this.state.tutorial_score_a3} onChange={this.setTutorialScoreA3}/>
                        </div>
                    </div>
                    <div className="formlike">
                        <select className="coach-script" value='none' onChange={ (e)=>{this.openCoachScriptEditor(e.target.value)} }>
                            <option hidden value='none'>Edit Coach Script</option>
                            {_.map(coachScripts,(entry,k)=>(
                                <option key={k} value={entry.id}>{entry.displayName}</option>
                            ))}
                        </select>
                    </div>
                    <div className="formlike">
                        <select className="coach-text" value='none' onChange={ this.onEditCoachText }>
                            <option hidden value='none'>Edit Coach Other Rich Text</option>
                            {_.map(coachRichTexts,(entry,k)=>(
                                <option key={k} value={entry.id}>{entry.displayName}</option>
                            ))}
                            <option key={'add'} value={'add'}>{'Add Rich Text'}</option>
                        </select>
                    </div>
                    <button className="btn btn-primary" onClick={this.openCoachStickerEditor}>
                        Edit Coach Stickers
                    </button>
                    <button className="btn btn-primary" onClick={this.openCoachStyleEditor}>
                        Edit Criteria Score Display
                    </button>
                    <button className="btn btn-primary" onClick={this.openVoiceOptions}>
                        Voice Options
                    </button>
                    <button className="btn btn-primary" onClick={this.openCourseCardOptions}>
                        Course Meta Data
                    </button>
                    <button className="btn btn-primary" onClick={this.openCoursePhraseSystemEditor}>
                        Phrases
                    </button>
                    <button className="btn btn-primary" onClick={this.openImportDataModal}>
                        Import
                    </button>

                    { anyBadgeTemplates ?
                    <div className="formlike">
                        <input id="issue-badge-checkbox" type="checkbox" checked={this.state.badge_parameters.issueBadge} onChange={this.setIssueBadge}/>
                        <label htmlFor="issue-badge-checkbox">Issue Badge on Completion</label>
                    </div>
                    : null }
                    { anyBadgeTemplates ?
                    <div className="formlike">
                        <select className="badge-template-dropdown" value={this.state.badge_parameters.badge_template_hash} onChange={ this.setBadgeTemplateId } disabled={!this.state.badge_parameters.issueBadge}>
                            <option hidden value='none'>{'Select Badge...'}</option>
                            {_.map(this.props.badgeTemplates,(entry,k)=>(
                                <option key={k} value={entry.badge_template_hash}>{entry.display_name}</option>
                            ))}
                        </select>
                    </div>
                    : null }

                </div>
                {this.renderActivitiesEditor()}
                {this.renderSubskills()}
                {this.state.edit_activity_id ? 
                <EditActivityDetailsModal courseLevel
                    closeHandler={()=>{this.setState({edit_activity_id:''})}}
                    modalTitleId="mzl-edit-activity-details"
                    modalTitle="Activity Details"
                    activity_type={this.getEditActivityType()}
                    score_categories={this.getEditActivityScoreCategories()}
                    subskills={this.state.subskills}
                    subskill_relations={this.state.edit_subskill_relations}
                    onSetActivityType={this.onSetActivityType}
                    onSetSubskillValue={this.onSetSubskillValue}
                    onSyncSubskills={this.onSyncSubskills}
                    activityTypes={this.props.activityTypes}
                />
                : null }
            </div>
        );
    }
    
    render() {
        var edit_subskill = _.find(this.state.subskills,{hash:this.state.subskill_hash});
        return (
            <Row className="short-course-node-editor-area">
                <GotoCommentIcon {...this.props.commentProps} navLoc={{type:ShortCourseConstants.NAV_TYPES.Settings}} />
                {this.renderElements()}
                { ((this.state.modalState === 'subskillEditor') && edit_subskill) ? 
                <EditSubskillModal
                    channelId={this.props.channelId}
                    doc={this.state.doc}
                    subskill_hash={this.state.subskill_hash}
                    closeHandler={ () => {this.closeSubskillEditor()} }
                />
                : null }

                { (this.state.modalState === 'coachStickersEditor') ? 
                <EditCoachStickersModal
                    courseHash={this.props.courseHash}
                    channelId={this.props.channelId}
                    doc={this.state.doc}
                    closeHandler={ () => {this.closeCoachStickerEditor()} }
                />
                : null }
                
                
                { (this.state.modalState === 'coachStyleEditor') ? 
                <CoachStyleEditorModal
                    app={this.props.app}
                    modalTitleId="mzl-coach-style-editor"
                    modalTitle="Coach Style Editor"
                    criteriaScoresStyle={this.state.criteriaScoresStyle}
                    onChangeTextStyle={this.onChangeCriteriaScoresStyle}
                    closeHandler={ () => {this.closeCoachStyleEditor()} }
                />
                : null }
                
                { (this.state.modalState === 'voiceOptions') ? 
                <VoiceOptionsModal
                    options={this.state.doc.client_content.voiceOptions || { }}
                    usageData={this.getUsageData()}
                    onChangeVoiceOptions={this.onChangeVoiceOptions}
                    closeHandler={ () => {this.closeVoiceOptions()} }
                />
                : null }

                { (this.state.modalState === 'courseCard') ? 
                <CourseCardEditorModal courseHash={this.props.courseHash}
                    options={this.state.doc.client_content.courseCard || { }}
                    onChangeOptions={this.onChangeCourseCardOptions}
                    closeHandler={ () => {this.closeCourseCardOptions()} }
                />
                : null }

                { (this.state.modalState === 'phraseSystem') ? 
                <CoursePhraseSystemEditorModal
                    phraseData={this.state.doc.client_content.phraseData || { }}
                    onChange={this.onChangePhraseSystem}
                    closeHandler={ () => {this.closeCoursePhraseSystemEditor()} }
                />
                : null }

                { (this.state.modalState === 'importData') ? 
                <ImportCourseDataModal
                    courseHash={this.props.courseHash}
                    doc={this.state.doc}
                    channelId={this.props.channelId}
                    projectId={this.props.projectId}
                    closeHandler={ () => {this.closeImportDataModal()} }
                />
                : null }



                { (this.state.modalState === 'coachScriptEditor') ? 
                <EditCoachScriptModal doc={this.state.doc} 
                    coachScriptId={this.state.coach_script_id} 
                    closeHandler={ () => {this.closeCoachScriptEditor()} }
                    commentProps={this.props.commentProps}
                    nonModal={this.props.editingComment}
                    onEditCoachText={(query,displayName)=>{
                        // close the coach script editor, then open it back up again after
                        let coach_script_id = this.state.coach_script_id;
                        let onDoneCallback=()=>{
                            this.setState({
                                modalState: 'coachScriptEditor',
                                coach_script_id,
                            });
                        };
                        this.closeCoachScriptEditor();
                        this.props.onEditCoachText(query,displayName,onDoneCallback,coach_script_id)
                    }}
                />
                : null }

                
            </Row>
        );
    }
    
}; // ShortCourseSettingsEditor

ShortCourseSettingsEditor.propTypes = propTypes;
ShortCourseSettingsEditor.defaultProps = defaultProps;

export default ShortCourseSettingsEditor;